import logoDark from "../assets/images/branding/adatis-logo-dark.png";
import logoLight from "../assets/images/branding/adatis-logo-light.png";
import logoWellness from "../assets/images/branding/adatis-logo-wellness.png";
import logoMenu from "../assets/images/branding/adatis-logo-menu.png";

/** Adatis brand assets — DOC 09 § 10.2 */
export const adatisLogos = {
  /** Wordmark Carbono & Titânio — fundos claros (páginas internas) */
  dark: logoDark,
  /** Wordmark claro — login, dark mode e fundos escuros */
  light: logoLight,
  /** Ícone quadrado da marca — menu (sidebar/header) e sidebar recolhida */
  sm: logoMenu,
  /** Ícone quadrado da marca — brand do menu (sidebar/header) */
  menu: logoMenu,
  /** Verde Sálvia / Floresta — splash e materiais promocionais */
  wellness: logoWellness,
} as const;

/** Design tokens Adatis — DOC 09 § 10.3 */
export const adatisColors = {
  primary: "#0F4C3A",
  secondary: "#7B8E78",
  success: "#059669",
  danger: "#E11D48",
  warning: "#D97706",
  info: "#334155",
  background: "#FAFAFA",
  text: "#1C1C1E",
} as const;

export const adatisProductName = "Adatis";
